import React from 'react';
import moment from 'moment';
import img1 from '../../Assets/custom-site/img_1.png';
import img2 from '../../Assets/custom-site/img_2.png';
import img3 from '../../Assets/custom-site/img_3.png';

const Hero = ({ clientName, spouse, daysUntilWedding, weddingDate, weddingImg, colourScheme, weddingTown, weddingCounty, otherImages }) => {
    return (
        <div className={`hero-bg ${colourScheme}-hero`}>
            <div className="hero-content-wrapper">

                {/* Left half - existing content */}
                <div className="hero-left">
                    <h1 className="client-name">{clientName ? clientName.split(" ")[0] : ""}</h1>
                    {clientName && spouse && <h2 id={`${colourScheme}-and`}>and</h2>}
                    <h1 className="client-name">{spouse ? spouse.split(" ")[0] : ""}</h1>

                    <p style={{ fontSize: 16, color: '#454C5C', textTransform: 'uppercase', fontWeight: 600, letterSpacing: 5, textAlign: 'center', margin: "50px 0 30px 0" }}>We're getting married</p>

                    <p id="hero-wedding-date" style={{ marginBottom: '30px' }}>{moment(weddingDate).format('Do MMMM YYYY')}</p>

                    {(weddingTown || weddingCounty) && (
                        <p style={{ fontSize: 16, color: '#454C5C', textTransform: 'uppercase', fontWeight: 600, letterSpacing: 5, textAlign: 'center', margin: 0 }}>
                            {[weddingTown, weddingCounty].filter(Boolean).join(', ')}
                        </p>
                    )}
                </div>

                {/* Right half - image collage */}
                <div className="hero-right">
                    <div className="image-collage">
                        {/* Image 1 - top, right aligned with image 2 */}
                        <img
                            src={weddingImg || img1}
                            alt="Wedding photo 1"
                            className="collage-img-1"
                        />

                        {/* Image 2 - below image 1, right aligned with it */}
                        <img
                            src={otherImages && otherImages[0] ? otherImages[0] : img2}
                            alt="Wedding photo 2"
                            className="collage-img-2"
                        />

                        {/* Image 3 - to the right, 150px below top */}
                        <img
                            src={otherImages && otherImages[1] ? otherImages[1] : img3}
                            alt="Wedding photo 3"
                            className="collage-img-3"
                        />

                        {/* Middle heart - center of all images */}
                        <img
                            src={require(`../../Assets/custom-site/${colourScheme}/middle-heart.png`)}
                            alt="Heart decoration"
                            className="collage-middle-heart"
                        />

                        {/* Bottom right heart - to the right of image 2 */}
                        <img
                            src={require(`../../Assets/custom-site/${colourScheme}/br-heart.png`)}
                            alt="Heart decoration"
                            className="collage-br-heart"
                        />

                        {/* Star - above image 2, centered on left edge */}
                        <img
                            src={require(`../../Assets/custom-site/${colourScheme}/star.png`)}
                            alt="Star decoration"
                            className="collage-star"
                        />

                        {/* Top right heart - above image 3 */}
                        <img
                            src={require(`../../Assets/custom-site/${colourScheme}/tr-heart.png`)}
                            alt="Heart decoration"
                            className="collage-tr-heart"
                        />
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Hero;   